import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findLevel'
})
export class FindLevelPipe implements PipeTransform {

  transform(levels: any[], lesson): any {
    if (levels && lesson) {
      const { levelKeys } = lesson;
      const item = levels.find(m => m.key === levelKeys[0])
      return item ? item.name : null
    }
    return null;
  }

}
